import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class InvoicingRuleService extends AbstractService {
	static endpoint = ENDPOINTS.invoicingRule;

	static getInvoiceRules(orgId) {
		return this.get({
			endpoint: `invoicingrule/${orgId}?asc=true`,
		});
	}

	static create(data) {
		return this.post({
			endpoint: this.endpoint,
			data,
		});
	}

	static update(data) {
		return this.put({
			endpoint: `${this.endpoint}/${data.Id}`,
			data,
		});
	}

	static delete(id) {
		return this.del({
			endpoint: `${this.endpoint}/${id}`,
		});
	}

	static bulkCriteriaUpdate(data) {
		return this.put({
			endpoint: `${this.endpoint}/bulkupdateeffectivedates`,
			data,
		});
	}

	static bulkCreate(data) {
		return this.post({
			endpoint: `${this.endpoint}/bulk`,
			data,
		});
	}
}
